import type { AnyStepContentElement } from '@flows/core/types/stepContentTypes'

export const isInputElement = <TElement extends NonNullable<AnyStepContentElement>>(
  element: TElement
) => {
  const elementType = element.type
  switch (elementType) {
    case 'choice':
    case 'yesNo':
    case 'radioCardSet':
    case 'selectionButtonSet':
    case 'checkbox':
    case 'input':
    case 'date':
    case 'dropDown':
    case 'phoneNumber':
    case 'codeInput':
    case 'editableList':
    case 'editableSet':
      return true
    case 'image':
    case 'infoBox':
    case 'title':
    case 'subtitle':
    case 'caption':
    case 'customComponent':
    case 'infoButton':
    case 'spacer':
    case 'text':
    case 'spinner':
    case 'harmonyTitle':
    case 'accordionList':
    case 'addressAutocomplete':
    case 'list':
    case 'columns':
    case 'animation':
    case 'calendly':
    case 'tag':
    case 'avatar':
    case 'itemActionList':
      return false
    default: {
      throw new Error(`Assertion: unexpected element type ${elementType}`)
    }
  }
}
